import type { BadgeStyle } from '../lib/format';

const FALLBACK: BadgeStyle = { bg: '#f1efe8', fg: '#5f5e5a', bd: '#b4b2a9' };

export function Badge({
  label,
  colors,
  fontSize,
}: {
  label: string;
  colors: Record<string, BadgeStyle>;
  fontSize?: number;
}) {
  const style = colors[label] ?? FALLBACK;
  return (
    <span
      className="badge"
      style={{
        background: style.bg,
        color: style.fg,
        borderColor: style.bd,
        ...(fontSize ? { fontSize } : {}),
      }}
    >
      {label}
    </span>
  );
}
